module.exports = __webpack_public_path__ + "static/QuickBrush-Web-c5572b646a5b1370f5493ed6c6063c17.woff";